import clsx from 'clsx';

import styled from '@emotion/styled';

import { capitalize, formatForStatus } from '../../utils/utils';
import DotIcon from '../Icons/DotIcon';

interface StatusCellProps {
  data?: Record<string, any>;
  statusKey?: string;
  plain?: boolean;
  customClasses?: string;
  useBoolean?: boolean;
  hasDot?: boolean;
}

const StatusCell: React.FC<StatusCellProps> = ({
  data,
  statusKey,
  plain = false,
  customClasses,
  useBoolean,
  hasDot,
}) => {
  let label = data && data[statusKey ?? ''];

  if (!label && !useBoolean) {
    label = statusKey;
  }

  if (data && typeof data['status'] === 'boolean') {
    label = Boolean(data['status']) ? ' active' : 'inactive';
  }

  let formatStatus = formatForStatus(String(label) ?? '');

  if (plain) {
    formatStatus = label;
  }

  return (
    <StatusCellWrapper
      className={clsx(
        `${formatForStatus(String(label) ?? '')} status`,
        customClasses,
      )}
    >
      {hasDot && <DotIcon />}
      {capitalize(formatStatus)}
    </StatusCellWrapper>
  );
};

export default StatusCell;

const StatusCellWrapper = styled.div`
  display: flex;
  background-color: yellow;
  width: fit-content;
  align-items: center;
  line-height: 12px;
  font-size: 12px;
  font-weight: 400;
  border-radius: 8px;
  padding: 4px 11px !important;
  user-select: none;
  height: fit-content;

  &.small-border-radius {
    border-radius: 4px;
  }

  &.declined {
    color: ${({ theme }) => theme.palette.errorRed};
    background-color: rgba(255, 5, 0, 0.1);
  }

  &.positive {
    color: ${({ theme }) => theme.palette.greenColor};
    background-color: rgba(0, 183, 63, 0.05);
  }

  &.exclusive {
    color: #139ab7;
    background-color: ${({ theme }) => theme.palette.infoBg};
  }

  &.gig {
    color: #f46f3b;
    background-color: rgba(244, 111, 59, 0.1);
  }

  /* TODO: make the color platinum below */
  &.platinum {
    color: #5b91f5;
    background-color: rgba(91, 145, 245, 0.1);
  }

  &.silver {
    color: #6b7280;
    background-color: rgba(244, 111, 59, 0.1);
  }

  &.processed {
    color: #ffc400;
    background-color: rgba(255, 196, 0, 0.1);
  }

  &.gold {
    color: #ffc400;
    background-color: rgba(255, 196, 0, 0.1);
  }

  &.pending,
  &.theft {
    background-color: rgba(213, 192, 27, 0.1);
    color: #d5c01b;
  }

  &.accepted,
  &.active,
  &.resolved,
  &.confirmed {
    background-color: rgba(0, 183, 63, 0.1);
    color: #00b73f;
  }

  &.rejected,
  &.deleted,
  &.accident,
  &.at-risk {
    background-color: rgba(255, 5, 0, 0.1);
    color: #ff0500;
  }

  &.exited {
    background-color: rgba(107, 114, 128, 0.05);
    color: ${({ theme }) => theme.palette.grayTextColor};
  }
`;
